module.exports = __webpack_public_path__ + "img/bell.72d62c00.svg";